var map = {
	"./add-business.svg": [
		38214,
		8214
	],
	"./add-check.svg": [
		77854,
		7854
	],
	"./add-task.svg": [
		40315
	],
	"./add.svg": [
		67186,
		7186
	],
	"./arrow-back.svg": [
		41422,
		1422
	],
	"./arrow-down.svg": [
		97196
	],
	"./arrow-dropdown.svg": [
		65995
	],
	"./arrow-going-down.svg": [
		56488,
		6488
	],
	"./arrow-going-right.svg": [
		47862,
		7862
	],
	"./arrow-going-up.svg": [
		42040,
		2040
	],
	"./arrow-left.svg": [
		95224
	],
	"./arrow-outward.svg": [
		26477,
		6477
	],
	"./arrow-right.svg": [
		74197
	],
	"./arrow-up.svg": [
		39392,
		9392
	],
	"./arrow-upward.svg": [
		79943
	],
	"./assignment.svg": [
		59350,
		9350
	],
	"./avatar.svg": [
		20699,
		699
	],
	"./ballot.svg": [
		35473,
		5473
	],
	"./ban-icon.svg": [
		77050,
		7050
	],
	"./box.svg": [
		38930,
		8930
	],
	"./building.svg": [
		28187,
		8187
	],
	"./bulk-creation.svg": [
		48335,
		8335
	],
	"./calculate.svg": [
		46254,
		6254
	],
	"./calendar.svg": [
		49477,
		9477
	],
	"./cancel-border-rounded.svg": [
		86746,
		6746
	],
	"./caret-down.svg": [
		72626,
		2626
	],
	"./category.svg": [
		11230,
		1230
	],
	"./chart-graphic-2.svg": [
		48627,
		8627
	],
	"./chart.svg": [
		10753,
		753
	],
	"./check-border-rounded.svg": [
		63362,
		3362
	],
	"./check-icon.svg": [
		53857,
		3857
	],
	"./check-rounded.svg": [
		85799,
		5799
	],
	"./check.svg": [
		60439
	],
	"./clear.svg": [
		83379
	],
	"./close-simple.svg": [
		55285,
		5285
	],
	"./close-small.svg": [
		46613
	],
	"./close.svg": [
		14847
	],
	"./copy.svg": [
		68362,
		8362
	],
	"./corporate-fare.svg": [
		12493,
		2493
	],
	"./dashboard.svg": [
		16959,
		6959
	],
	"./delete-trash.svg": [
		33755,
		3755
	],
	"./delete.svg": [
		81440,
		1440
	],
	"./devices-other.svg": [
		3100,
		3100
	],
	"./directions-car.svg": [
		98305,
		8305
	],
	"./document.svg": [
		80862,
		862
	],
	"./domain.svg": [
		26790,
		6790
	],
	"./done-all.svg": [
		1193,
		1193
	],
	"./done.svg": [
		85043,
		5043
	],
	"./dots.svg": [
		2903,
		2903
	],
	"./double-check-circle.svg": [
		60293,
		293
	],
	"./download-file.svg": [
		14266,
		4266
	],
	"./download.svg": [
		86876,
		6876
	],
	"./edit-black.svg": [
		4934,
		4934
	],
	"./ellipse.svg": [
		32841,
		2841
	],
	"./email-sent.svg": [
		9208,
		9208
	],
	"./empty-state.svg": [
		61006,
		1006
	],
	"./error-filled.svg": [
		15242,
		5242
	],
	"./error-icon.svg": [
		91159
	],
	"./error-simple.svg": [
		34559,
		4559
	],
	"./exclamation.svg": [
		36523
	],
	"./exit-to-app.svg": [
		68275
	],
	"./expand-more-simple.svg": [
		15026,
		5026
	],
	"./expand_more.svg": [
		81418
	],
	"./export.svg": [
		88962,
		8962
	],
	"./feed.svg": [
		90863,
		863
	],
	"./file-document.svg": [
		84797,
		4797
	],
	"./file-extension.svg": [
		94432,
		4432
	],
	"./file-upload.svg": [
		66330,
		6330
	],
	"./filter-icon.svg": [
		46321,
		6321
	],
	"./filter-list.svg": [
		3009,
		3009
	],
	"./flag.svg": [
		62824,
		2824
	],
	"./flight-takeoff.svg": [
		27460,
		7460
	],
	"./forecasting.svg": [
		51970,
		1970
	],
	"./hand.svg": [
		38446,
		8446
	],
	"./help.svg": [
		57937,
		7937
	],
	"./highlight-off.svg": [
		52752,
		2752
	],
	"./hub.svg": [
		79949,
		9949
	],
	"./info-fill.svg": [
		821,
		821
	],
	"./info-warning.svg": [
		65561
	],
	"./integrations.svg": [
		70723,
		723
	],
	"./inventory-2.svg": [
		38765
	],
	"./inventory-black.svg": [
		94981,
		4981
	],
	"./inventory_2.svg": [
		87835,
		7835
	],
	"./item-check.svg": [
		23270,
		3270
	],
	"./local-mall.svg": [
		68576,
		8576
	],
	"./local_convenience_store.svg": [
		70488,
		488
	],
	"./local_shipping.svg": [
		89892,
		9892
	],
	"./local_unshipping.svg": [
		82160,
		2160
	],
	"./more-vert.svg": [
		29420
	],
	"./motion_photos_on.svg": [
		48124,
		8124
	],
	"./multiple-stop.svg": [
		5305,
		5305
	],
	"./mvnifest-logo.svg": [
		31699,
		1699
	],
	"./navigate-right.svg": [
		16932,
		6932
	],
	"./no-filters.svg": [
		22189,
		2189
	],
	"./no-items-search.svg": [
		11615,
		1615
	],
	"./no-items.svg": [
		85224
	],
	"./notes.svg": [
		7103,
		7103
	],
	"./on-hold.svg": [
		29097,
		9097
	],
	"./pages.svg": [
		84987,
		4987
	],
	"./person-pin.svg": [
		38696,
		8696
	],
	"./photo-filter.svg": [
		9042,
		9042
	],
	"./pin-drop.svg": [
		11372,
		1372
	],
	"./place.svg": [
		34317,
		4317
	],
	"./planning.svg": [
		12809,
		2809
	],
	"./play-for-work.svg": [
		85213,
		5213
	],
	"./playlist-add-check.svg": [
		95788,
		5788
	],
	"./plus.svg": [
		44448,
		4448
	],
	"./poll.svg": [
		20217,
		217
	],
	"./question-mark-2.svg": [
		70331,
		331
	],
	"./question-mark.svg": [
		98126,
		8126
	],
	"./radio_button_checked_black.svg": [
		6383,
		6383
	],
	"./refresh.svg": [
		7470,
		7470
	],
	"./release-icon.svg": [
		12715,
		2715
	],
	"./remove-business.svg": [
		4299,
		4299
	],
	"./remove-task.svg": [
		75205,
		5205
	],
	"./sand-clock.svg": [
		15909,
		5909
	],
	"./save-alt.svg": [
		55701
	],
	"./score.svg": [
		99499,
		9499
	],
	"./search.svg": [
		46293
	],
	"./semicircle-dots.svg": [
		50302,
		302
	],
	"./semitriangle-dots.svg": [
		86495,
		6495
	],
	"./shapes-figures.svg": [
		33670,
		3670
	],
	"./share.svg": [
		46177,
		6177
	],
	"./shopping-bag.svg": [
		63992,
		3992
	],
	"./shopping-cart.svg": [
		6515,
		6515
	],
	"./single-creation.svg": [
		24419,
		4419
	],
	"./spinner.svg": [
		68918,
		8918
	],
	"./square.svg": [
		23342,
		3342
	],
	"./sticky_note.svg": [
		73592,
		3592
	],
	"./storefront.svg": [
		13515
	],
	"./straighten.svg": [
		32274,
		2274
	],
	"./style.svg": [
		29426,
		9426
	],
	"./sync.svg": [
		16769,
		6769
	],
	"./table-rows.svg": [
		49709,
		9709
	],
	"./task-alt.svg": [
		24387,
		4387
	],
	"./task.svg": [
		72081,
		2081
	],
	"./timelapse.svg": [
		22374,
		2374
	],
	"./today.svg": [
		53200
	],
	"./toolbar-icon-compact.svg": [
		48816,
		8816
	],
	"./toolbar-icon-default.svg": [
		74686,
		4686
	],
	"./tooltip-2.svg": [
		54815,
		4815
	],
	"./tooltip.svg": [
		64850,
		4850
	],
	"./trash-fit.svg": [
		21832,
		1832
	],
	"./tune.svg": [
		51745,
		1745
	],
	"./unarchive.svg": [
		96898,
		6898
	],
	"./unship-rounded.svg": [
		50522,
		522
	],
	"./upcoming.svg": [
		51505,
		1505
	],
	"./upload-box.svg": [
		6821,
		6821
	],
	"./upload-document.svg": [
		38566,
		8566
	],
	"./upload-file.svg": [
		30481,
		481
	],
	"./upload.svg": [
		56177,
		993
	],
	"./warehouse.svg": [
		98683,
		8683
	],
	"./warning-error.svg": [
		63706
	],
	"./warning-simple.svg": [
		16726,
		6726
	],
	"./warning.svg": [
		445
	],
	"./waves.svg": [
		6789,
		6789
	],
	"./widgets.svg": [
		86709,
		6709
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 62873;
module.exports = webpackAsyncContext;